import React from 'react'
import { Card } from '@offerzen/pinata'

import styles from './styles'

const EmptyListCard = () => {
  return (
    <Card className={styles.emptyListCard}>
      <h4>There aren&apos;t jobs that match your profile</h4>
      <p>
        Don&apos;t worry, this doesn&apos;t mean there aren&apos;t jobs available on OfferZen for you. Not all companies list their jobs
        here. Check back again later.
      </p>
    </Card>
  )
}

export default EmptyListCard
